var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 2.875,
    stroke: "#424895",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.1187L5.1373 15.2846C4.17611 14.3291 3.52194 13.1121 3.25696 11.7878C2.99198 10.4634 3.12795 9.09069 3.64784 7.84298C4.16774 6.59523 5.04841 5.52816 6.17905 4.77714C7.30973 4.02609 8.63944 3.625 10 3.625C11.3606 3.625 12.6903 4.02609 13.821 4.77714C14.9516 5.52816 15.8323 6.59523 16.3522 7.84298C16.872 9.09069 17.008 10.4634 16.743 11.7877C16.4781 13.1121 15.8239 14.3291 14.8627 15.2846L10 20.1187Z",
    stroke: "#424895",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.a27e80a896c273c2f3552d103f6acff1.svg";
export { ForwardRef as ReactComponent };